import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, Tooltip } from '@mui/material';
import classNames from 'classnames';
import { useState, type PropsWithChildren } from 'react';
import { ButtonWithIcon } from './buttonWithIcon';
interface CopyToClipboardProps {
  buttonLabel?: string;
  textToCopy?: string;
  tooltip?: string;
  disabledTooltip?: string;
  className?: string;
  size?: 'small' | 'medium';
  showOnlyOnHover?: boolean;
}
export function CopyToClipboardButton(props) {
  const $ = _c(12);
  const {
    textToCopy,
    tooltip: t0,
    disabledTooltip: t1,
    buttonLabel,
    showOnlyOnHover: t2,
    size: t3
  } = props;
  const tooltip = t0 === undefined ? "Copy" : t0;
  const disabledTooltip = t1 === undefined ? tooltip : t1;
  const showOnlyOnHover = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "medium" : t3;
  const [copySuccess, setCopySuccess] = useState(false);
  let t4;
  if ($[0] !== textToCopy) {
    t4 = e => {
      e.stopPropagation();
      if (!textToCopy) {
        return;
      }
      navigator.clipboard.writeText(textToCopy).then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      }).catch(() => {
        setCopySuccess(false);
      });
    };
    $[0] = textToCopy;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleCopy = t4;
  let t5;
  if ($[2] !== buttonLabel || $[3] !== copySuccess || $[4] !== disabledTooltip || $[5] !== handleCopy || $[6] !== props.className || $[7] !== showOnlyOnHover || $[8] !== size || $[9] !== textToCopy || $[10] !== tooltip) {
    t5 = buttonLabel ? <Tooltip title={copySuccess ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "4px"
    }}><i className="material-symbols-check text-[18px]" /> Copied</Stack> : undefined}><ButtonWithIcon variant="outlined" text={buttonLabel} onClick={handleCopy} disabled={!textToCopy} className={classNames({
        "opacity-0 group-hover/copy:opacity-100 transition-opacity": showOnlyOnHover,
        "min-w-[24px] min-h-[24px] w-[24px] h-[24px]": size === "small"
      })} icon={`material-symbols-content-copy-outline ${props.className ?? ""}`} /></Tooltip> : <Tooltip title={copySuccess ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "4px"
    }}><i className="material-symbols-check text-[18px]" /> Copied</Stack> : !textToCopy ? disabledTooltip : tooltip}><span><IconButton size={size} color="primary" aria-label={tooltip} onClick={handleCopy} className={classNames({
          "opacity-0 group-hover/copy:opacity-100 transition-opacity": showOnlyOnHover
        })} disabled={!textToCopy}><i className={classNames("material-symbols-content-copy-outline", props.className)} /></IconButton></span></Tooltip>;
    $[2] = buttonLabel;
    $[3] = copySuccess;
    $[4] = disabledTooltip;
    $[5] = handleCopy;
    $[6] = props.className;
    $[7] = showOnlyOnHover;
    $[8] = size;
    $[9] = textToCopy;
    $[10] = tooltip;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export const copyToClipboardGroupKey = 'group/copy';
export const CopyToClipboardWrapper = t0 => {
  const $ = _c(14);
  let children;
  let rest;
  let t1;
  let textToCopy;
  if ($[0] !== t0) {
    ({
      children,
      gap: t1,
      textToCopy,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = t1;
    $[4] = textToCopy;
  } else {
    children = $[1];
    rest = $[2];
    t1 = $[3];
    textToCopy = $[4];
  }
  const gap = t1 === undefined ? "4px" : t1;
  if (!textToCopy) {
    return children;
  }
  let t2;
  if ($[5] !== gap) {
    t2 = {
      alignItems: "center",
      gap
    };
    $[5] = gap;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rest || $[8] !== textToCopy) {
    t3 = <CopyToClipboardButton showOnlyOnHover={true} size="small" textToCopy={textToCopy} {...rest} />;
    $[7] = rest;
    $[8] = textToCopy;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className={`${copyToClipboardGroupKey} overflow-hidden`}><Stack direction="row" sx={t2}>{children}{t3}</Stack></div>;
    $[10] = children;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};